export default "/images/left-arrow-icon.png?12ba7228f767481580b7bd342f936a03";